import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function postAppointmentConfig({
  preferenceFor,
  preferences,
}: {
  preferenceFor: string;
  preferences: any;
}): Promise<TrystGenericResponse<{}>> {
  const TRYST_HOST = GET_TRYST_HOST();
  const headers = new Headers();

  headers.append("accept", "application/json");
  headers.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers,
    credentials: "include",
    body: JSON.stringify({
      preferenceFor,
      preferences,
    }),
  };

  const response = await fetch(
    `${TRYST_HOST}/queue-config/appointment-config`,
    requestOptions
  );

  const aptConfigResponse = await response.json();
  const { success, error } = aptConfigResponse;

  if (!success) {
    throw new Error(error || "Failed to set appointment config!");
  }

  return { success: true };
}
